export default "__VITE_PUBLIC_ASSET__3b298f25__"